import { useRef, useState } from "react";
import { MODAL_TYPE } from "../../constants";
import Modal from "../modal/Modal";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import useEventBus from "../../hooks/useEventBus";
import { useMySizeProfile } from "../../context/mySizeProfile/MySizeProfileContext";
import { MY_SIZE_PROFILE_OPEN_MODAL_EVENT } from "./constants";
import eventBusEmitter from "../../utils/eventBusEmitter";
import styles from "./MySizeProfileModal.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

export default function MySizeProfileModal() {
  const [open, setOpen] = useState<boolean>(false);
  const focusOnCloseRef = useRef<HTMLElement | null>(null);
  const findMySizeRef = useRef<HTMLElement | null>(null);
  const {
    mySizeProfile,
    dismissed,
    dismissMySizeProfile,
    isEligible,
    isAuthenticated,
  } = useMySizeProfile();
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  useEventBus(
    MY_SIZE_PROFILE_OPEN_MODAL_EVENT,
    ({
      focusOnCloseElement,
    }: { focusOnCloseElement?: HTMLElement | null } = {}) => {
      if (!isEligible || !isAuthenticated || mySizeProfile || dismissed) {
        return;
      }
      focusOnCloseRef.current = focusOnCloseElement ?? null;
      setOpen(true);
    },
    [isEligible, isAuthenticated, mySizeProfile, dismissed],
  );

  const closeModal = () => {
    setOpen(false);
  };

  const dismissModal = () => {
    dismissMySizeProfile();
    closeModal();
  };

  const handleFindMySize = () => {
    closeModal();
    eventBusEmitter("sizeHelpOpen", {
      focusOnClose: findMySizeRef.current,
    });
  };

  return (
    <Modal
      modalType={MODAL_TYPE.CENTER}
      modalId="MySizeProfileModal"
      open={open}
      contentLoaded={true}
      closeModal={dismissModal}
      focusOnClose={focusOnCloseRef.current}
      withScrollBar={false}
    >
      <div className={styles.container}>
        <h2 id="modalTitle" className={styles.title}>
          {getTranslation("pdp_my_size_profile_modal_title")}
        </h2>
        <p className={styles.body}>
          {getTranslation("pdp_my_size_profile_modal_text")}
        </p>
        <Button
          handleClick={handleFindMySize}
          type={BUTTON_TYPES.primaryMySizeProfile}
          dataTestId="msp-find-my-size"
          buttonRef={findMySizeRef}
        >
          {getTranslation("pdp_my_size_profile_modal_cta")}
        </Button>
        <Button
          handleClick={dismissModal}
          type={BUTTON_TYPES.secondaryMySizeProfile}
          dataTestId="msp-no-thanks"
        >
          {getTranslation("pdp_my_size_profile_modal_dismiss")}
        </Button>
      </div>
    </Modal>
  );
}
